module.exports = __webpack_public_path__ + "img/dummyprod3@1x.9a775b32.png";